var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkill4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 32.6552 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.69 6.435L18.3 0.45C17.04 -0.15 15.63 -0.15 14.37 0.45L1.98 6.435C0.78 7.02 0 8.25 0 9.57V21.06C0 21.63 0.179998 34.995 15.945 38.955C16.05 38.985 16.17 39 16.275 39H16.38C16.485 39 16.605 38.985 16.71 38.955C32.475 34.995 32.655 21.63 32.655 21.06V9.57C32.67 8.25 31.89 7.02 30.69 6.435ZM23.16 21.42H17.985V26.595H14.685V21.42H9.51V20.79H9.465V18.75H9.51V18.12H14.685V12.945H17.97V18.12H23.145V21.42H23.16Z",
    fill: "var(--fill-0, #07B7B7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill4);
export default __webpack_public_path__ + "static/media/skill-4.812821a7482858331c28faea1499ee93.svg";
export { ForwardRef as ReactComponent };